import {
  NOTIFICATION_ADD,
  NOTIFICATION_REMOVE } from './constants';
import { createSelector } from 'reselect';

const initialState = {
  notifications: {}
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case NOTIFICATION_ADD: {
      const notification = {
        id: action.id,
        title: action.title,
        message: action.message,
        severity: action.severity
      };
      const notifications = JSON.parse(JSON.stringify(state.notifications));
      try {
        const items = Object.values(notifications);
        for (let i = 0; i < items.length; i++) {
          const item = items[i];
          if (item.title === notification.title &&
            item.message === notification.message &&
            item.severity === notification.severity) {
            return state; // ignore this notification - we already have one like this.
          }
        }
      } catch (error) {
        // TODO - track this - but throttle the logging
      }
      notifications[notification.id] = notification;
      return { ...state, notifications };
    }
    case NOTIFICATION_REMOVE:
      const notifications = JSON.parse(JSON.stringify(state.notifications));
      delete notifications[action.id];
      return { ...state, notifications };
  }
  return state;
};

export default reducer;

const notifications = state => state.notifications.notifications;

export const getNotifications = createSelector(
  notifications, notifications => Object.values(notifications)
);
